import AOS from "aos";

export default () => {
  AOS.init();
};
